import React, { useState } from 'react';
import { Row, Button, FormGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Formik, Field } from 'formik';
import PropTypes from 'prop-types';

import Alert from '../../../../../components/Alert';
import FormComponent from '../../../../../components/Form';

import { getFormFields } from './helpers';
import { paymentsSelector } from '../../../../../redux/selectors/payments';
import { getUsersList } from '../../../../../redux/actions/payments';

const ExportForm = ({ config, toggle, onSubmit }) => {
  const { statuses, modes, methods, access, defaults } = config;

  const [success, setSuccess] = useState(false);

  const { users } = useSelector((state) => paymentsSelector(state));

  const handleSubmit = async (values, actions) => {
    onSubmit(values, { ...actions, setSuccess });
  };

  return (
    <Formik
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      validateOnBlur={false}
      validateOnChange={false}
      initialValues={{
        date: {
          startDate: defaults?.from,
          endDate: defaults?.to,
        },
        include_users: [],
        include_statuses: statuses?.map((item) => item.title),
        include_methods: methods?.map((item) => item.id),
        include_modes: 'All',
      }}
    >
      {({ errors, setFieldValue, values, submitForm }) => (
        <FormComponent handleSubmit={handleSubmit} disableKeyUp>
          <div className="export__wrapper export__wrapper-orders">
            {errors.length && <Alert text={errors} />}
            {success && <Alert text="Your request is being processed" type="success" dismiss />}
            <Row className="export__row">
              {getFormFields(statuses, modes, users, defaults?.to, defaults?.from, getUsersList, methods, access).map((el, index) => (
                <div className={`export__col${el.name === 'include_modes' ? ' modes' : ''}`} key={index}>
                  <FormGroup>
                    <label className="control-label">{el.labelName}</label>
                    <Field
                      component={el.component}
                      title={values.include_modes}
                      fieldName={el.name}
                      setFieldValue={setFieldValue}
                      options={el.data}
                      items={el.data}
                      handleSelect={(value) => {
                        if (el.name === 'include_modes') {
                          return setFieldValue(el.name, modes.find((item) => item.id === value)?.title);
                        }

                        setFieldValue(el.name, value[0].toUpperCase() + value.substr(1));
                      }}
                      onChange={(value) => setFieldValue(el.name, value)}
                      toolbarClass={values?.include_statuses?.length ? '' : el.toolbarClassStr}
                      {...el}
                    />
                  </FormGroup>
                </div>
              ))}
              <div className="export__col">
                <Button bsStyle="link" className="export__col-modal" onClick={() => toggle?.()}>
                  Customize columns
                </Button>
                <Button bsStyle="primary" className="export__col-submit" onClick={() => submitForm?.()}>
                  Create file
                </Button>
              </div>
            </Row>
          </div>
        </FormComponent>
      )}
    </Formik>
  );
};

ExportForm.propTypes = {
  config: PropTypes.object,
  toggle: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default ExportForm;
